import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-[#0f172a] text-white overflow-hidden" data-id="element-108">
      {/* Decorative stars */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-109">
        <SparklesIcon className="absolute top-20 left-[10%] w-4 h-4 text-[#d4a853] opacity-40" data-id="element-110" />
        <SparklesIcon className="absolute top-40 right-[15%] w-3 h-3 text-[#d4a853] opacity-30" data-id="element-111" />
        <SparklesIcon className="absolute bottom-32 left-[20%] w-3 h-3 text-[#d4a853] opacity-50" data-id="element-112" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 lg:py-32" data-id="element-113">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-114">
          {/* Left: Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-115">
            <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight text-white" data-id="element-116">
              El Protocolo Adiós Insomnio: El Método de Enfriamiento Biológico
              para Dormir 7 Horas Seguidas{' '}
              <span className="text-[#d4a853]" data-id="element-117">(Incluso en la Menopausia)</span>
            </h1>

            <h2 className="text-xl md:text-2xl text-gray-300 font-normal leading-relaxed" data-id="element-118">
              Apaga tu mente, enfría tu cuerpo y recupera el descanso profundo
              que perdiste hace años sin depender de pastillas pesadas.
            </h2>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} className="space-y-4" data-id="element-119">
              <motion.a href="#precio" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              document.getElementById('precio')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.98
            }} className="inline-block w-full sm:w-auto bg-[#d4a853] text-[#0f172a] px-10 py-5 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow text-center cursor-pointer" data-id="element-120">
                ¡SÍ, QUIERO DORMIR MEJOR!
              </motion.a>
              <p className="text-sm text-gray-400" data-id="element-121">
                Pago 100% seguro · Acceso instantáneo
              </p>
            </motion.div>
          </motion.div>

          {/* Right: Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="relative" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/hma3Z4ejbTvqazVNPQvqq6/heylloyd-image-Insomnio.png" alt="Protocolo Adiós Insomnio en dispositivos" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-123" />
          </motion.div>
        </div>
      </div>
    </section>;
}